// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== MOBILE FIRST CSS ===== */

/* ===== DESIGN TOKENS (terminal redesign) ===== */
/* See docs/adr/0001-bespoke-css-no-component-library.md. Consumed today by
   the nav; remaining sections adopt these token-by-token as their own
   redesign tickets land. */

:root {
  /* Colors */
  --navy: #222732;
  --navy-panel: #3b4252;
  --ink: #eceff4;
  --ink-dim: rgba(226, 239, 244, 0.7);
  --cyan: #5df5ff;
  --cyan-dim: rgba(93, 245, 255, 0.35);
  --cyan-hover: #2ae8f4;
  --accent: #f2a93b;
  --accent-dim: rgba(242, 169, 59, 0.35);
  --line: rgba(112, 226, 236, 0.18);
  /* Layout */
  --maxw: 1080px;
  --radius-sm: 2px;
  --radius-lg: 8px;
  /* Spacing */
  --space-sm: 8px;
  --space-md: 16px;
  --space-lg: clamp(20px, 5vw, 64px);
  /* Typography */
  --font-mono: "IBM Plex Mono", ui-monospace, monospace;
  --font-sans: "IBM Plex Sans", system-ui, sans-serif;
}

/* ===== BASE / MOBILE STYLES (0px - 767px) ===== */

body {
  font-family: var(--font-sans);
  background-color: var(--navy);
  color: var(--ink);
  overflow-x: hidden;
}

.page {
  max-width: var(--maxw);
  margin: 0 auto;
}

/* ===== COMPONENTS ===== */

/* ---- Navigation/App Bar ---- */
.nav {
  position: sticky;
  top: 0;
  z-index: 50;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-md);
  padding: var(--space-md) var(--space-lg);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--line);
  font-family: var(--font-mono);
}

.logo {
  font-weight: 700;
  font-size: 1rem;
  text-decoration: none;
  color: var(--ink);
  text-transform: lowercase;
}

.logo span {
  color: var(--cyan);
}

.logo-img {
  height: 25px;
  padding-right: 3px;
  vertical-align: middle;
}

.nav-burger {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 38px;
  height: 38px;
  padding: 8px;
  background: none;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
}

.nav-burger span {
  display: block;
  width: 100%;
  height: 2px;
  background: var(--ink);
}

.nav-links {
  display: none;
  flex-basis: 100%;
  flex-direction: column;
  gap: var(--space-sm);
  margin: 0;
  padding: var(--space-md) 0 0;
  list-style: none;
}

.nav-links.open {
  display: flex;
}

.nav-links a {
  text-decoration: none;
  color: var(--ink-dim);
  font-size: 0.82rem;
  font-weight: 500;
  text-transform: lowercase;
}

.nav-links a span {
  color: var(--cyan);
}

.nav-links a:hover,
.nav-links a:focus-visible {
  color: var(--cyan);
}

/* ---- Hero ---- */
.hero {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: clamp(48px, 8vw, 80px) var(--space-lg) 0;
}

.eyebrow {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  color: var(--cyan);
  margin: 0 0 10px;
  text-transform: uppercase;
}

.hero h1 {
  font-family: var(--font-mono);
  font-weight: 700;
  text-transform: uppercase;
  font-size: clamp(2.6rem, 9vw, 5.6rem);
  line-height: 0.94;
  letter-spacing: -0.01em;
  margin: 0 0 6px;
  cursor: default;
  display: inline-block;
}

.hero h1:hover {
  animation: heroGlitch 0.4s steps(2) infinite;
}

@keyframes heroGlitch {
  0% {
    transform: translate(0, 0);
  }
  20% {
    transform: translate(-2px, 1px);
  }
  40% {
    transform: translate(2px, -1px);
  }
  60% {
    transform: translate(-1px, 2px);
  }
  80% {
    transform: translate(1px, -2px);
  }
  100% {
    transform: translate(0, 0);
  }
}

.hero .title {
  font-family: var(--font-mono);
  font-size: clamp(1rem, 2vw, 1.2rem);
  color: var(--cyan);
  margin: 0 0 28px;
}

.hero-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  align-items: start;
  margin-top: 8px;
}

.hero-left .tags {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.tag {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  padding: 5px 11px;
  border: 1px solid var(--cyan-dim);
  border-radius: var(--radius-sm);
  color: var(--ink-dim);
}

.cta-row {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin: 22px 0;
}

.btn {
  font-family: var(--font-mono);
  font-size: 0.85rem;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: var(--radius-sm);
  font-weight: 600;
  text-transform: lowercase;
}

.btn.primary {
  background: var(--cyan);
  color: var(--navy);
}

.btn.primary:hover {
  background: var(--cyan-hover);
}

.btn.ghost {
  border: 1px solid var(--cyan-dim);
  color: var(--ink);
}

.btn.ghost:hover {
  border-color: var(--cyan);
  color: var(--cyan);
}

.social {
  display: flex;
  gap: 10px;
}

.social a {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  text-decoration: none;
  color: var(--ink-dim);
  border: 1px solid var(--line);
  padding: 6px 12px;
  border-radius: var(--radius-sm);
}

.social a:hover {
  color: var(--cyan);
  border-color: var(--cyan-dim);
}

/* ---- Terminal card ---- */
.terminal {
  background: var(--navy-panel);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
  cursor: pointer;
}

.sr-only {
  width: 1px;
  height: 1px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  border: 0;
}

.sr-only:focus-visible {
  width: auto;
  height: auto;
  overflow: visible;
  white-space: normal;
  outline: 2px solid var(--cyan);
  outline-offset: 2px;
}

.terminal-bar {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 11px 14px;
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid var(--line);
}

.terminal-bar .dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--ink-dim);
  opacity: 0.5;
}

.terminal-bar .dot:last-child {
  background: var(--cyan);
  opacity: 0.9;
}

.terminal-bar .path {
  margin-left: 6px;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--ink-dim);
}

.terminal-body {
  padding: 20px 18px;
  font-family: var(--font-mono);
  font-size: 0.88rem;
  min-height: 190px;
}

.ascii-cat {
  margin: 0 0 9px;
  font-family: var(--font-mono);
  color: var(--accent);
  white-space: pre;
  opacity: 0;
  animation: catReveal 0.25s ease 0.35s forwards;
}

@keyframes catReveal {
  to {
    opacity: 1;
  }
}

.type-line {
  white-space: nowrap;
  overflow: hidden;
  width: 0;
  display: block;
  margin-bottom: 9px;
}

.type-line.output {
  color: var(--accent);
}

/* Each line's steps()/width must match its string length in
   heroTerminal (src/constants/appData.ts) or the reveal clips early. */
.tl-whoami {
  animation: typeWhoami 0.25s steps(8) 0.15s forwards;
}
.tl-whoami-reply {
  animation: typeWhoamiReply 0.25s steps(10) 0.55s forwards;
}
.tl-role {
  animation: typeRole 0.35s steps(14) 0.95s forwards;
}
.tl-role-reply {
  animation: typeRoleReply 0.65s steps(28) 1.45s forwards;
}
.tl-photo {
  animation: typePhoto 0.35s steps(15) 2.25s forwards;
}
.tl-status {
  animation: typeStatus 0.3s steps(13) 3s forwards;
}
.tl-status-reply {
  animation: typeStatusReply 0.5s steps(21) 3.45s forwards;
}
/* Mounted on click, not page load, so no fixed offset delay — it should
   start typing as soon as the cat reveal appears. */
.tl-cat {
  animation: typeCat 0.35s steps(20) forwards;
}

@keyframes typeWhoami {
  to {
    width: 8ch;
  }
}
@keyframes typeWhoamiReply {
  to {
    width: 10ch;
  }
}
@keyframes typeRole {
  to {
    width: 14ch;
  }
}
@keyframes typeRoleReply {
  to {
    width: 28ch;
  }
}
@keyframes typePhoto {
  to {
    width: 15ch;
  }
}
@keyframes typeStatus {
  to {
    width: 13ch;
  }
}
@keyframes typeStatusReply {
  to {
    /* 21ch fits the text alone; the extra 1ch makes room for the nested
       .cursor so overflow:hidden doesn't clip it off. */
    width: calc(21ch + 1ch);
  }
}
@keyframes typeCat {
  to {
    width: 20ch;
  }
}

.cursor {
  display: inline-block;
  width: 0.85em;
  height: 1em;
  background: var(--cyan);
  vertical-align: text-bottom;
  animation: blink 1s step-end infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

.terminal-photo-frame {
  position: relative;
  display: block;
  width: 96px;
  height: 96px;
  margin: 4px 0 14px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--cyan-dim);
  overflow: hidden;
  opacity: 0;
  animation: photoReveal 0.2s ease 2.7s forwards;
}

.terminal-photo-frame::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--navy), var(--accent));
  mix-blend-mode: color;
}

.terminal-photo {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(1);
}

@keyframes photoReveal {
  to {
    opacity: 1;
  }
}

/* ---- Stat band ---- */
.stat-band {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-top: 40px;
  margin-left: -50vw;
  margin-right: -50vw;
  background: var(--cyan);
}

.stat-band-inner {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 28px var(--space-lg);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-lg) var(--space-md);
}

.stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat-value {
  font-family: var(--font-mono);
  font-weight: 700;
  font-size: clamp(1.6rem, 4vw, 2.2rem);
  color: var(--navy);
}

.stat-label {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(14, 22, 48, 0.7);
}

/* ---- Section prompt heading ---- */
.prompt {
  font-family: var(--font-mono);
  font-size: clamp(1.3rem, 3vw, 1.7rem);
  font-weight: 600;
  text-transform: lowercase;
  margin: 0 0 24px;
}

.prompt-symbol {
  color: var(--cyan);
}

/* ----- About ----- */
.about {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 60px var(--space-lg);
}

.about-file-count {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--ink-dim);
  opacity: 0.85;
  margin: 0 0 24px;
}

.about-editor {
  max-width: 100%;
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--navy-panel);
}

.tab-bar {
  display: none;
  background: rgba(255, 255, 255, 0.02);
  border-bottom: 1px solid var(--line);
  overflow-x: auto;
}

.tab-label {
  font-family: var(--font-mono);
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--ink-dim);
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 13px 18px;
  cursor: pointer;
  white-space: nowrap;
}

.tab-label:hover {
  color: var(--ink);
}

.tab-label[aria-selected="true"] {
  color: var(--cyan);
  border-bottom-color: var(--cyan);
  background: rgba(255, 255, 255, 0.03);
}

.about-select-wrap {
  padding: 14px 18px;
  border-bottom: 1px solid var(--line);
}

.about-select {
  width: 100%;
  font-family: var(--font-mono);
  font-size: 0.85rem;
  color: var(--ink);
  background: var(--navy-panel);
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  padding: 9px 10px;
}

.about-panels {
  padding: 22px 22px 26px;
}

.about-lead {
  color: var(--ink-dim);
  font-size: 1.02rem;
}

.about a {
  color: var(--cyan);
  text-decoration: underline;
}

.about a:hover {
  text-decoration: none;
}

.accordion-group {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  margin: 24px 0;
}

.accordion {
  background: var(--navy-panel);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.accordion summary {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 11px 14px;
  font-family: var(--font-mono);
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--ink);
  cursor: pointer;
  list-style: none;
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid var(--line);
}

.accordion summary::-webkit-details-marker {
  display: none;
}

.accordion summary .dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--ink-dim);
  opacity: 0.5;
}

.disclosure-icon {
  display: inline-block;
  color: var(--cyan);
}

.disclosure-icon::before {
  content: "▸";
}

.accordion[open] .disclosure-icon::before {
  content: "▾";
}

.accordion summary:hover,
.accordion summary:focus-visible {
  color: var(--cyan);
}

.accordion-body {
  padding: 14px 18px;
}

.accordion-body p {
  margin: 0;
  color: var(--ink-dim);
  font-size: 0.95rem;
}

.accomplishments {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
}

.accomplishments li {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  color: var(--ink-dim);
  font-size: 0.95rem;
}

.accomplishments .check {
  flex-shrink: 0;
  color: var(--cyan);
}

.accomplishments strong {
  color: var(--ink);
}

/* ----- Skills ----- */
.skills {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 60px var(--space-lg);
}

.pipeline-caption {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--ink-dim);
  opacity: 0.85;
  margin: 0 0 40px;
}

.pipeline-caption b {
  color: var(--cyan);
  font-weight: 500;
}

/* ---- pipeline rail: each category is a numbered stage on a vertical rail ---- */
.stage-rail {
  position: relative;
}

.rail-line {
  position: absolute;
  left: 15px;
  top: 4px;
  bottom: 4px;
  width: 2px;
  background: linear-gradient(
    to bottom,
    transparent,
    var(--cyan-dim) 4%,
    var(--cyan-dim) 96%,
    transparent
  );
  overflow: hidden;
  border-radius: 2px;
}

/* Positioned with top/height in % (not fixed px) so the traveling glow stays
   correct however tall a stage's content is — a fixed-offset version of this
   broke once category sizes diverged from an even split to the real 7/6/10. */
.rail-pulse {
  position: absolute;
  left: -5px;
  top: -16%;
  width: 12px;
  height: 16%;
  background: linear-gradient(to bottom, transparent, var(--cyan), transparent);
  filter: drop-shadow(0 0 6px var(--cyan));
  animation: railFlow 5s linear infinite;
}

@keyframes railFlow {
  to {
    top: 116%;
  }
}

.stage {
  position: relative;
  display: grid;
  grid-template-columns: 32px 1fr;
  column-gap: 18px;
  padding-bottom: 40px;
}

.stage:last-child {
  padding-bottom: 0;
}

.stage-node {
  position: relative;
  z-index: 2;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--navy);
  border: 2px solid var(--cyan);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--cyan);
  box-shadow: 0 0 0 4px rgba(242, 169, 59, 0.12);
  animation: nodePulse 2.6s ease-in-out infinite;
}

@keyframes nodePulse {
  0%,
  100% {
    box-shadow: 0 0 0 4px rgba(242, 169, 59, 0.12);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(242, 169, 59, 0.04);
  }
}

.stage-head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: 12px;
  row-gap: 4px;
  margin-top: 2px;
  margin-bottom: 14px;
}

.stage-kicker {
  font-family: var(--font-mono);
  font-size: 0.68rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--accent);
  opacity: 0.85;
}

.stage-name {
  font-family: var(--font-mono);
  font-size: 1rem;
  font-weight: 600;
  color: var(--ink);
  margin: 0;
  text-transform: lowercase;
}

.stage-name span {
  color: var(--cyan);
}

.stage-status {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--ink-dim);
}

.stage-status b {
  color: var(--accent);
  font-weight: 500;
}

.skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.skill-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--navy-panel);
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  padding: 8px 12px;
  transition:
    border-color 0.2s ease,
    transform 0.2s ease;
}

.skill-item:hover {
  border-color: var(--cyan-dim);
  transform: translateY(-2px);
}

.skill-item-core {
  border-color: var(--cyan-dim);
}

.skill-name {
  font-family: var(--font-mono);
  font-size: 0.85rem;
  color: var(--ink);
  margin: 0;
}

.skill-years {
  font-family: var(--font-mono);
  font-size: 0.68rem;
  color: var(--cyan);
  border: 1px solid var(--cyan-dim);
  border-radius: var(--radius-sm);
  padding: 2px 6px;
  white-space: nowrap;
}
/* ----- Projects ----- */
.projects {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 60px var(--space-lg);
}

.projects-eyebrow {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink-dim);
  margin: 0 0 10px;
}

.projects-caption {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--ink-dim);
  opacity: 0.85;
  margin: 0 0 40px;
}

.projects-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
}

.project-card {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--navy-panel);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  padding: 20px;
}

.project-number {
  position: absolute;
  top: 10px;
  right: 16px;
  font-family: var(--font-mono);
  font-size: 2.6rem;
  font-weight: 700;
  color: var(--ink);
  opacity: 0.5;
  line-height: 1;
}

.project-title {
  font-family: var(--font-mono);
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--ink);
  margin: 0 24px 4px 0;
}

.project-subtitle {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--cyan);
  opacity: 0.85;
  margin: 0 0 12px;
}

.project-description {
  color: var(--ink-dim);
  font-size: 0.95rem;
  margin: 0 0 12px;
}

.project-impact {
  font-size: 0.9rem;
  color: var(--ink-dim);
  border-left: 2px solid var(--accent-dim);
  padding-left: 12px;
  margin: 0 0 16px;
}

.project-impact strong {
  color: var(--accent);
}

.project-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.project-links {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: auto;
  padding-top: 4px;
}

.project-link {
  font-family: var(--font-mono);
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--cyan);
  text-decoration: none;
}

.project-link:hover {
  color: var(--cyan-hover);
  text-decoration: underline;
}

/* ----- Footer ----- */
.footer {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: var(--space-lg) var(--space-lg) var(--space-md);
  border-top: 1px solid var(--line);
  font-family: var(--font-mono);
  text-align: center;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-sm) var(--space-md);
  list-style: none;
  margin: 0 0 24px;
  padding: 0;
}

.footer-link {
  color: var(--ink-dim);
  text-decoration: none;
  font-size: 0.85rem;
}

.footer-link:hover,
.footer-link:focus-visible {
  color: var(--cyan);
}

.footer-privacy {
  margin: 0 0 8px;
  font-size: 0.75rem;
  color: var(--ink-dim);
}

.footer-copyright {
  margin: 0;
  font-size: 0.8rem;
  color: var(--ink-dim);
}

/* ===== RESPONSIVE DESIGN ===== */

/* TABLET (768px - 1099px) */

@media screen and (min-width: 768px) {
  .nav-burger {
    display: none;
  }

  .nav-links {
    display: flex;
    flex-basis: auto;
    flex-direction: row;
    gap: clamp(14px, 3vw, 32px);
    padding: 0;
  }
  .hero-grid {
    grid-template-columns: 1fr 340px;
  }

  .stat-band-inner {
    grid-template-columns: repeat(4, 1fr);
  }

  .tab-bar {
    display: flex;
  }

  .about-select-wrap {
    display: none;
  }
}

/* DESKTOP (1100px and up) */
@media screen and (min-width: 1100px) {
  .nav-burger {
    display: none;
  }

  .nav-links {
    display: flex;
    flex-basis: auto;
    flex-direction: row;
    gap: clamp(14px, 3vw, 32px);
    padding: 0;
  }

  .project-title {
    max-width: 200px;
    word-wrap: break-word;
  }
}

/* ===== ACCESSIBILITY ===== */
/* Focus visible for keyboard navigation */
a:focus-visible,
button:focus-visible {
  outline: 2px solid var(--cyan);
  outline-offset: 2px;
}
/* Reduced motion for users who prefer it */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-delay: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/new.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,kDAAkD;AAClD;;2BAE2B;;AAE3B;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;EACjB,sCAAsC;EACtC,iCAAiC;EACjC,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,qDAAqD;EACrD,mDAAmD;AACrD;;AAEA,mDAAmD;;AAEnD;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA,2BAA2B;;AAE3B,iCAAiC;AACjC;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,wCAAwC;EACxC,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;uEACuE;AACvE;EACE,mDAAmD;AACrD;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,kDAAkD;AACpD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,wDAAwD;AAC1D;AACA;oDACoD;AACpD;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE;wDACoD;IACpD,uBAAuB;EACzB;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;EAChB,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,6BAA6B;EAC7B,aAAa;EACb,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,qCAAqC;AACrC;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV;;;;;;GAMC;EACD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;8EAE8E;AAC9E;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,WAAW;EACX,6EAA6E;EAC7E,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE;;IAEE,8CAA8C;EAChD;EACA;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,iBAAiB;EACjB;;uBAEqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;AACA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,cAAc;EACd,wDAAwD;EACxD,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,kCAAkC;;AAElC,4BAA4B;;AAE5B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,gCAAgC;EAClC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA,8BAA8B;AAC9B,0CAA0C;AAC1C;;EAEE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,2CAA2C;AAC3C;EACE;;;IAGE,qCAAqC;IACrC,kCAAkC;IAClC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":["/* ===== MOBILE FIRST CSS ===== */\n\n/* ===== DESIGN TOKENS (terminal redesign) ===== */\n/* See docs/adr/0001-bespoke-css-no-component-library.md. Consumed today by\n   the nav; remaining sections adopt these token-by-token as their own\n   redesign tickets land. */\n\n:root {\n  /* Colors */\n  --navy: #222732;\n  --navy-panel: #3b4252;\n  --ink: #eceff4;\n  --ink-dim: rgba(226, 239, 244, 0.7);\n  --cyan: #5df5ff;\n  --cyan-dim: rgba(93, 245, 255, 0.35);\n  --cyan-hover: #2ae8f4;\n  --accent: #f2a93b;\n  --accent-dim: rgba(242, 169, 59, 0.35);\n  --line: rgba(112, 226, 236, 0.18);\n  /* Layout */\n  --maxw: 1080px;\n  --radius-sm: 2px;\n  --radius-lg: 8px;\n  /* Spacing */\n  --space-sm: 8px;\n  --space-md: 16px;\n  --space-lg: clamp(20px, 5vw, 64px);\n  /* Typography */\n  --font-mono: \"IBM Plex Mono\", ui-monospace, monospace;\n  --font-sans: \"IBM Plex Sans\", system-ui, sans-serif;\n}\n\n/* ===== BASE / MOBILE STYLES (0px - 767px) ===== */\n\nbody {\n  font-family: var(--font-sans);\n  background-color: var(--navy);\n  color: var(--ink);\n  overflow-x: hidden;\n}\n\n.page {\n  max-width: var(--maxw);\n  margin: 0 auto;\n}\n\n/* ===== COMPONENTS ===== */\n\n/* ---- Navigation/App Bar ---- */\n.nav {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-md);\n  padding: var(--space-md) var(--space-lg);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid var(--line);\n  font-family: var(--font-mono);\n}\n\n.logo {\n  font-weight: 700;\n  font-size: 1rem;\n  text-decoration: none;\n  color: var(--ink);\n  text-transform: lowercase;\n}\n\n.logo span {\n  color: var(--cyan);\n}\n\n.logo-img {\n  height: 25px;\n  padding-right: 3px;\n  vertical-align: middle;\n}\n\n.nav-burger {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 5px;\n  width: 38px;\n  height: 38px;\n  padding: 8px;\n  background: none;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n}\n\n.nav-burger span {\n  display: block;\n  width: 100%;\n  height: 2px;\n  background: var(--ink);\n}\n\n.nav-links {\n  display: none;\n  flex-basis: 100%;\n  flex-direction: column;\n  gap: var(--space-sm);\n  margin: 0;\n  padding: var(--space-md) 0 0;\n  list-style: none;\n}\n\n.nav-links.open {\n  display: flex;\n}\n\n.nav-links a {\n  text-decoration: none;\n  color: var(--ink-dim);\n  font-size: 0.82rem;\n  font-weight: 500;\n  text-transform: lowercase;\n}\n\n.nav-links a span {\n  color: var(--cyan);\n}\n\n.nav-links a:hover,\n.nav-links a:focus-visible {\n  color: var(--cyan);\n}\n\n/* ---- Hero ---- */\n.hero {\n  max-width: var(--maxw);\n  margin: 0 auto;\n  padding: clamp(48px, 8vw, 80px) var(--space-lg) 0;\n}\n\n.eyebrow {\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n  letter-spacing: 0.08em;\n  color: var(--cyan);\n  margin: 0 0 10px;\n  text-transform: uppercase;\n}\n\n.hero h1 {\n  font-family: var(--font-mono);\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: clamp(2.6rem, 9vw, 5.6rem);\n  line-height: 0.94;\n  letter-spacing: -0.01em;\n  margin: 0 0 6px;\n  cursor: default;\n  display: inline-block;\n}\n\n.hero h1:hover {\n  animation: heroGlitch 0.4s steps(2) infinite;\n}\n\n@keyframes heroGlitch {\n  0% {\n    transform: translate(0, 0);\n  }\n  20% {\n    transform: translate(-2px, 1px);\n  }\n  40% {\n    transform: translate(2px, -1px);\n  }\n  60% {\n    transform: translate(-1px, 2px);\n  }\n  80% {\n    transform: translate(1px, -2px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n.hero .title {\n  font-family: var(--font-mono);\n  font-size: clamp(1rem, 2vw, 1.2rem);\n  color: var(--cyan);\n  margin: 0 0 28px;\n}\n\n.hero-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 40px;\n  align-items: start;\n  margin-top: 8px;\n}\n\n.hero-left .tags {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n}\n\n.tag {\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n  padding: 5px 11px;\n  border: 1px solid var(--cyan-dim);\n  border-radius: var(--radius-sm);\n  color: var(--ink-dim);\n}\n\n.cta-row {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin: 22px 0;\n}\n\n.btn {\n  font-family: var(--font-mono);\n  font-size: 0.85rem;\n  text-decoration: none;\n  padding: 12px 20px;\n  border-radius: var(--radius-sm);\n  font-weight: 600;\n  text-transform: lowercase;\n}\n\n.btn.primary {\n  background: var(--cyan);\n  color: var(--navy);\n}\n\n.btn.primary:hover {\n  background: var(--cyan-hover);\n}\n\n.btn.ghost {\n  border: 1px solid var(--cyan-dim);\n  color: var(--ink);\n}\n\n.btn.ghost:hover {\n  border-color: var(--cyan);\n  color: var(--cyan);\n}\n\n.social {\n  display: flex;\n  gap: 10px;\n}\n\n.social a {\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n  text-decoration: none;\n  color: var(--ink-dim);\n  border: 1px solid var(--line);\n  padding: 6px 12px;\n  border-radius: var(--radius-sm);\n}\n\n.social a:hover {\n  color: var(--cyan);\n  border-color: var(--cyan-dim);\n}\n\n/* ---- Terminal card ---- */\n.terminal {\n  background: var(--navy-panel);\n  border: 1px solid var(--line);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n}\n\n.sr-only {\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  border: 0;\n}\n\n.sr-only:focus-visible {\n  width: auto;\n  height: auto;\n  overflow: visible;\n  white-space: normal;\n  outline: 2px solid var(--cyan);\n  outline-offset: 2px;\n}\n\n.terminal-bar {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 11px 14px;\n  background: rgba(255, 255, 255, 0.03);\n  border-bottom: 1px solid var(--line);\n}\n\n.terminal-bar .dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--ink-dim);\n  opacity: 0.5;\n}\n\n.terminal-bar .dot:last-child {\n  background: var(--cyan);\n  opacity: 0.9;\n}\n\n.terminal-bar .path {\n  margin-left: 6px;\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  color: var(--ink-dim);\n}\n\n.terminal-body {\n  padding: 20px 18px;\n  font-family: var(--font-mono);\n  font-size: 0.88rem;\n  min-height: 190px;\n}\n\n.ascii-cat {\n  margin: 0 0 9px;\n  font-family: var(--font-mono);\n  color: var(--accent);\n  white-space: pre;\n  opacity: 0;\n  animation: catReveal 0.25s ease 0.35s forwards;\n}\n\n@keyframes catReveal {\n  to {\n    opacity: 1;\n  }\n}\n\n.type-line {\n  white-space: nowrap;\n  overflow: hidden;\n  width: 0;\n  display: block;\n  margin-bottom: 9px;\n}\n\n.type-line.output {\n  color: var(--accent);\n}\n\n/* Each line's steps()/width must match its string length in\n   heroTerminal (src/constants/appData.ts) or the reveal clips early. */\n.tl-whoami {\n  animation: typeWhoami 0.25s steps(8) 0.15s forwards;\n}\n.tl-whoami-reply {\n  animation: typeWhoamiReply 0.25s steps(10) 0.55s forwards;\n}\n.tl-role {\n  animation: typeRole 0.35s steps(14) 0.95s forwards;\n}\n.tl-role-reply {\n  animation: typeRoleReply 0.65s steps(28) 1.45s forwards;\n}\n.tl-photo {\n  animation: typePhoto 0.35s steps(15) 2.25s forwards;\n}\n.tl-status {\n  animation: typeStatus 0.3s steps(13) 3s forwards;\n}\n.tl-status-reply {\n  animation: typeStatusReply 0.5s steps(21) 3.45s forwards;\n}\n/* Mounted on click, not page load, so no fixed offset delay — it should\n   start typing as soon as the cat reveal appears. */\n.tl-cat {\n  animation: typeCat 0.35s steps(20) forwards;\n}\n\n@keyframes typeWhoami {\n  to {\n    width: 8ch;\n  }\n}\n@keyframes typeWhoamiReply {\n  to {\n    width: 10ch;\n  }\n}\n@keyframes typeRole {\n  to {\n    width: 14ch;\n  }\n}\n@keyframes typeRoleReply {\n  to {\n    width: 28ch;\n  }\n}\n@keyframes typePhoto {\n  to {\n    width: 15ch;\n  }\n}\n@keyframes typeStatus {\n  to {\n    width: 13ch;\n  }\n}\n@keyframes typeStatusReply {\n  to {\n    /* 21ch fits the text alone; the extra 1ch makes room for the nested\n       .cursor so overflow:hidden doesn't clip it off. */\n    width: calc(21ch + 1ch);\n  }\n}\n@keyframes typeCat {\n  to {\n    width: 20ch;\n  }\n}\n\n.cursor {\n  display: inline-block;\n  width: 0.85em;\n  height: 1em;\n  background: var(--cyan);\n  vertical-align: text-bottom;\n  animation: blink 1s step-end infinite;\n}\n\n@keyframes blink {\n  50% {\n    opacity: 0;\n  }\n}\n\n.terminal-photo-frame {\n  position: relative;\n  display: block;\n  width: 96px;\n  height: 96px;\n  margin: 4px 0 14px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--cyan-dim);\n  overflow: hidden;\n  opacity: 0;\n  animation: photoReveal 0.2s ease 2.7s forwards;\n}\n\n.terminal-photo-frame::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, var(--navy), var(--accent));\n  mix-blend-mode: color;\n}\n\n.terminal-photo {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: grayscale(1);\n}\n\n@keyframes photoReveal {\n  to {\n    opacity: 1;\n  }\n}\n\n/* ---- Stat band ---- */\n.stat-band {\n  width: 100vw;\n  position: relative;\n  left: 50%;\n  right: 50%;\n  margin-top: 40px;\n  margin-left: -50vw;\n  margin-right: -50vw;\n  background: var(--cyan);\n}\n\n.stat-band-inner {\n  max-width: var(--maxw);\n  margin: 0 auto;\n  padding: 28px var(--space-lg);\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: var(--space-lg) var(--space-md);\n}\n\n.stat {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.stat-value {\n  font-family: var(--font-mono);\n  font-weight: 700;\n  font-size: clamp(1.6rem, 4vw, 2.2rem);\n  color: var(--navy);\n}\n\n.stat-label {\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(14, 22, 48, 0.7);\n}\n\n/* ---- Section prompt heading ---- */\n.prompt {\n  font-family: var(--font-mono);\n  font-size: clamp(1.3rem, 3vw, 1.7rem);\n  font-weight: 600;\n  text-transform: lowercase;\n  margin: 0 0 24px;\n}\n\n.prompt-symbol {\n  color: var(--cyan);\n}\n\n/* ----- About ----- */\n.about {\n  max-width: var(--maxw);\n  margin: 0 auto;\n  padding: 60px var(--space-lg);\n}\n\n.about-file-count {\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n  color: var(--ink-dim);\n  opacity: 0.85;\n  margin: 0 0 24px;\n}\n\n.about-editor {\n  max-width: 100%;\n  border: 1px solid var(--line);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--navy-panel);\n}\n\n.tab-bar {\n  display: none;\n  background: rgba(255, 255, 255, 0.02);\n  border-bottom: 1px solid var(--line);\n  overflow-x: auto;\n}\n\n.tab-label {\n  font-family: var(--font-mono);\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--ink-dim);\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  padding: 13px 18px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.tab-label:hover {\n  color: var(--ink);\n}\n\n.tab-label[aria-selected=\"true\"] {\n  color: var(--cyan);\n  border-bottom-color: var(--cyan);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.about-select-wrap {\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--line);\n}\n\n.about-select {\n  width: 100%;\n  font-family: var(--font-mono);\n  font-size: 0.85rem;\n  color: var(--ink);\n  background: var(--navy-panel);\n  border: 1px solid var(--line);\n  border-radius: var(--radius-sm);\n  padding: 9px 10px;\n}\n\n.about-panels {\n  padding: 22px 22px 26px;\n}\n\n.about-lead {\n  color: var(--ink-dim);\n  font-size: 1.02rem;\n}\n\n.about a {\n  color: var(--cyan);\n  text-decoration: underline;\n}\n\n.about a:hover {\n  text-decoration: none;\n}\n\n.accordion-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n  margin: 24px 0;\n}\n\n.accordion {\n  background: var(--navy-panel);\n  border: 1px solid var(--line);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.accordion summary {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 11px 14px;\n  font-family: var(--font-mono);\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--ink);\n  cursor: pointer;\n  list-style: none;\n  background: rgba(255, 255, 255, 0.03);\n  border-bottom: 1px solid var(--line);\n}\n\n.accordion summary::-webkit-details-marker {\n  display: none;\n}\n\n.accordion summary .dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--ink-dim);\n  opacity: 0.5;\n}\n\n.disclosure-icon {\n  display: inline-block;\n  color: var(--cyan);\n}\n\n.disclosure-icon::before {\n  content: \"▸\";\n}\n\n.accordion[open] .disclosure-icon::before {\n  content: \"▾\";\n}\n\n.accordion summary:hover,\n.accordion summary:focus-visible {\n  color: var(--cyan);\n}\n\n.accordion-body {\n  padding: 14px 18px;\n}\n\n.accordion-body p {\n  margin: 0;\n  color: var(--ink-dim);\n  font-size: 0.95rem;\n}\n\n.accomplishments {\n  list-style: none;\n  margin: 12px 0 0;\n  padding: 0;\n}\n\n.accomplishments li {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n  color: var(--ink-dim);\n  font-size: 0.95rem;\n}\n\n.accomplishments .check {\n  flex-shrink: 0;\n  color: var(--cyan);\n}\n\n.accomplishments strong {\n  color: var(--ink);\n}\n\n/* ----- Skills ----- */\n.skills {\n  max-width: var(--maxw);\n  margin: 0 auto;\n  padding: 60px var(--space-lg);\n}\n\n.pipeline-caption {\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n  color: var(--ink-dim);\n  opacity: 0.85;\n  margin: 0 0 40px;\n}\n\n.pipeline-caption b {\n  color: var(--cyan);\n  font-weight: 500;\n}\n\n/* ---- pipeline rail: each category is a numbered stage on a vertical rail ---- */\n.stage-rail {\n  position: relative;\n}\n\n.rail-line {\n  position: absolute;\n  left: 15px;\n  top: 4px;\n  bottom: 4px;\n  width: 2px;\n  background: linear-gradient(\n    to bottom,\n    transparent,\n    var(--cyan-dim) 4%,\n    var(--cyan-dim) 96%,\n    transparent\n  );\n  overflow: hidden;\n  border-radius: 2px;\n}\n\n/* Positioned with top/height in % (not fixed px) so the traveling glow stays\n   correct however tall a stage's content is — a fixed-offset version of this\n   broke once category sizes diverged from an even split to the real 7/6/10. */\n.rail-pulse {\n  position: absolute;\n  left: -5px;\n  top: -16%;\n  width: 12px;\n  height: 16%;\n  background: linear-gradient(to bottom, transparent, var(--cyan), transparent);\n  filter: drop-shadow(0 0 6px var(--cyan));\n  animation: railFlow 5s linear infinite;\n}\n\n@keyframes railFlow {\n  to {\n    top: 116%;\n  }\n}\n\n.stage {\n  position: relative;\n  display: grid;\n  grid-template-columns: 32px 1fr;\n  column-gap: 18px;\n  padding-bottom: 40px;\n}\n\n.stage:last-child {\n  padding-bottom: 0;\n}\n\n.stage-node {\n  position: relative;\n  z-index: 2;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--navy);\n  border: 2px solid var(--cyan);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--cyan);\n  box-shadow: 0 0 0 4px rgba(242, 169, 59, 0.12);\n  animation: nodePulse 2.6s ease-in-out infinite;\n}\n\n@keyframes nodePulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 4px rgba(242, 169, 59, 0.12);\n  }\n  50% {\n    box-shadow: 0 0 0 8px rgba(242, 169, 59, 0.04);\n  }\n}\n\n.stage-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  column-gap: 12px;\n  row-gap: 4px;\n  margin-top: 2px;\n  margin-bottom: 14px;\n}\n\n.stage-kicker {\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--accent);\n  opacity: 0.85;\n}\n\n.stage-name {\n  font-family: var(--font-mono);\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--ink);\n  margin: 0;\n  text-transform: lowercase;\n}\n\n.stage-name span {\n  color: var(--cyan);\n}\n\n.stage-status {\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  color: var(--ink-dim);\n}\n\n.stage-status b {\n  color: var(--accent);\n  font-weight: 500;\n}\n\n.skills-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.skill-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--navy-panel);\n  border: 1px solid var(--line);\n  border-radius: var(--radius-sm);\n  padding: 8px 12px;\n  transition:\n    border-color 0.2s ease,\n    transform 0.2s ease;\n}\n\n.skill-item:hover {\n  border-color: var(--cyan-dim);\n  transform: translateY(-2px);\n}\n\n.skill-item-core {\n  border-color: var(--cyan-dim);\n}\n\n.skill-name {\n  font-family: var(--font-mono);\n  font-size: 0.85rem;\n  color: var(--ink);\n  margin: 0;\n}\n\n.skill-years {\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  color: var(--cyan);\n  border: 1px solid var(--cyan-dim);\n  border-radius: var(--radius-sm);\n  padding: 2px 6px;\n  white-space: nowrap;\n}\n/* ----- Projects ----- */\n.projects {\n  max-width: var(--maxw);\n  margin: 0 auto;\n  padding: 60px var(--space-lg);\n}\n\n.projects-eyebrow {\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--ink-dim);\n  margin: 0 0 10px;\n}\n\n.projects-caption {\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n  color: var(--ink-dim);\n  opacity: 0.85;\n  margin: 0 0 40px;\n}\n\n.projects-grid {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n}\n\n.project-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--navy-panel);\n  border: 1px solid var(--line);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n}\n\n.project-number {\n  position: absolute;\n  top: 10px;\n  right: 16px;\n  font-family: var(--font-mono);\n  font-size: 2.6rem;\n  font-weight: 700;\n  color: var(--ink);\n  opacity: 0.5;\n  line-height: 1;\n}\n\n.project-title {\n  font-family: var(--font-mono);\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--ink);\n  margin: 0 24px 4px 0;\n}\n\n.project-subtitle {\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n  color: var(--cyan);\n  opacity: 0.85;\n  margin: 0 0 12px;\n}\n\n.project-description {\n  color: var(--ink-dim);\n  font-size: 0.95rem;\n  margin: 0 0 12px;\n}\n\n.project-impact {\n  font-size: 0.9rem;\n  color: var(--ink-dim);\n  border-left: 2px solid var(--accent-dim);\n  padding-left: 12px;\n  margin: 0 0 16px;\n}\n\n.project-impact strong {\n  color: var(--accent);\n}\n\n.project-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.project-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: auto;\n  padding-top: 4px;\n}\n\n.project-link {\n  font-family: var(--font-mono);\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--cyan);\n  text-decoration: none;\n}\n\n.project-link:hover {\n  color: var(--cyan-hover);\n  text-decoration: underline;\n}\n\n/* ----- Footer ----- */\n.footer {\n  max-width: var(--maxw);\n  margin: 0 auto;\n  padding: var(--space-lg) var(--space-lg) var(--space-md);\n  border-top: 1px solid var(--line);\n  font-family: var(--font-mono);\n  text-align: center;\n}\n\n.footer-links {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: var(--space-sm) var(--space-md);\n  list-style: none;\n  margin: 0 0 24px;\n  padding: 0;\n}\n\n.footer-link {\n  color: var(--ink-dim);\n  text-decoration: none;\n  font-size: 0.85rem;\n}\n\n.footer-link:hover,\n.footer-link:focus-visible {\n  color: var(--cyan);\n}\n\n.footer-privacy {\n  margin: 0 0 8px;\n  font-size: 0.75rem;\n  color: var(--ink-dim);\n}\n\n.footer-copyright {\n  margin: 0;\n  font-size: 0.8rem;\n  color: var(--ink-dim);\n}\n\n/* ===== RESPONSIVE DESIGN ===== */\n\n/* TABLET (768px - 1099px) */\n\n@media screen and (min-width: 768px) {\n  .nav-burger {\n    display: none;\n  }\n\n  .nav-links {\n    display: flex;\n    flex-basis: auto;\n    flex-direction: row;\n    gap: clamp(14px, 3vw, 32px);\n    padding: 0;\n  }\n  .hero-grid {\n    grid-template-columns: 1fr 340px;\n  }\n\n  .stat-band-inner {\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n  .tab-bar {\n    display: flex;\n  }\n\n  .about-select-wrap {\n    display: none;\n  }\n}\n\n/* DESKTOP (1100px and up) */\n@media screen and (min-width: 1100px) {\n  .nav-burger {\n    display: none;\n  }\n\n  .nav-links {\n    display: flex;\n    flex-basis: auto;\n    flex-direction: row;\n    gap: clamp(14px, 3vw, 32px);\n    padding: 0;\n  }\n\n  .project-title {\n    max-width: 200px;\n    word-wrap: break-word;\n  }\n}\n\n/* ===== ACCESSIBILITY ===== */\n/* Focus visible for keyboard navigation */\na:focus-visible,\nbutton:focus-visible {\n  outline: 2px solid var(--cyan);\n  outline-offset: 2px;\n}\n/* Reduced motion for users who prefer it */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-delay: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
